// extracted by mini-css-extract-plugin
module.exports = {"customSugesstions":"AddressInput_customSugesstions__26I57","spin":"AddressInput_spin__2oe6j"};